export const MOBILE_TABS = {
  Questions: 'Questions',
  Settings: 'Settings',
};

export const DOCUMENT_TYPES = {
  Quiz: 'Quiz',
  Form: 'Form',
};
